(ns app.front.view.group.admin.phrases
  (:require [app.front.entities :as entities]
            [app.front.file.download :as file-download]
            [app.front.file.upload :as upload]
            [app.front.ui :as ui]
            [app.front.ui.modal :as ui-modal]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.section :as section]
            [app.front.ui.table :as ui-table]
            [app.front.ui.tag-type-editor :as ui-tag-type-editor]
            [app.front.util :refer [for-all for-frag] :as futil]
            [app.front.view.conditions.common :as condition-common]
            [app.front.view.group.admin.subs :as gas]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt] :as event]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx ::create-category
  (fn [_ [_ group-id category & [on-done]]]
    {:comm/command {:command    :group/add-phrase-category
                    :method     :post
                    :data       {:group-id             group-id
                                 :phrase.category/name category}
                    :on-success [::create-category.success on-done]}}))

(rf/reg-event-fx ::create-category.success
  (fn [{:keys [db]} [_ on-done status resp]]
    (when on-done (on-done))
    {:db         (assoc db ::selected-phrase-category (ffirst resp))
     :dispatch-n [[::entities/merge-entity-db status resp]
                  [:notifications/add :toast :success :success ""]]}))

(rf/reg-event-fx ::edit-category
  (fn [_ [_ group-id id new-name]]
    {:comm/command {:command    :group/edit-phrase-category
                    :method     :post
                    :data       (util/mmap {:phrase.category/name new-name}
                                           group-id id)
                    :on-success [::entities/apply-changes]}}))

(rf/reg-event-fx ::delete-category
  (fn [_ [_ group-id id]]
    {:comm/command {:command    :group/delete-phrase-category
                    :method     :post
                    :data       (util/mmap group-id id)
                    :on-success [::entities/apply-changes]}}))

(rf/reg-event-fx ::update-default-category-success
  (fn [_ [_ status resp]]
    {:dispatch-n [[::entities/override-entity-db status resp]
                  [:notifications/add :toast :success :success ""]]}))

(rf/reg-event-fx ::save-phrase
  (fn [_ [_ group-id phrase-data]]
    {:comm/command {:command    (if (:phrase-id phrase-data)
                                  :group/update-phrase
                                  :group/create-phrase)
                    :method     :post
                    :data       (merge {:group-id group-id}
                                       phrase-data)
                    :on-success [::save-phrase-success]}}))

(rf/reg-event-fx ::save-phrase-success
  (fn [_ [_ status resp]]
    {:dispatch-n [[::entities/merge-entity-db status resp]
                  [:notifications/add :toast :success :success ""]]}))

(rf/reg-event-fx ::delete-phrase
  (fn [_ [_ group-id phrase-id]]
    {:comm/command {:command    :group/delete-phrase
                    :method     :post
                    :data       {:group-id  group-id
                                 :phrase-id phrase-id}
                    :on-success [::delete-phrase-success]}}))

(rf/reg-event-fx ::delete-phrase-success
  (fn [_ [_ _ {:keys [removed-entity]}]]
    {:dispatch-n [[::entities/remove-entity removed-entity]
                  [:notifications/add :toast :success :success ""]]}))

(rf/reg-event-fx ::import-standard-texts
  (fn [_ [_ group-id {:keys [file-id filename file-mime-type md5-base64]}]]
    {:dispatch [:comm/command-monitored {:command    :group/import-standard-texts
                                         :method     :post
                                         :data       {:group-id          group-id
                                                      :file-id           file-id
                                                      :file/filename     filename
                                                      :file/content-type file-mime-type
                                                      :file/md5          md5-base64}
                                         :notify     {:success :standard-texts/import-started}
                                         :on-success [::entities/apply-changes]}]}))

(rf/reg-event-fx ::refresh-standard-texts
  (fn [_ [_ group-id]]
    {:comm/command {:command    :group/configuration
                    :method     :get
                    :data       {:group-id group-id}
                    :on-success [::refresh-standard-texts.success group-id]}}))

(rf/reg-event-fx ::refresh-standard-texts.success
  (fn [_ [_ group-id status resp]]
    {:dispatch [::entities/override-entity-db-for-all
                {:entity/type            #(contains? #{:entity.type/phrase
                                                       :entity.type/phrase-category}
                                                     %)
                 :domain/authority-group group-id}
                status
                resp]}))

(rf/reg-event-fx ::update-default-category
  (fn [_ [_ key value remove auth-group-id]]
    {:comm/command {:command    :group/set-default-phrase-category
                    :method     :post
                    :data       (p/assoc-if {:key      key
                                             :group-id auth-group-id}
                                            :phrase-category-id value
                                            :remove remove)
                    :on-success [::update-default-category-success]}}))

(rf/reg-event-db ::set-phrase-category
  (fn [db [_ category-id]]
    (assoc db ::selected-phrase-category category-id)))

(rf/reg-sub ::selected-phrase-category :-> ::selected-phrase-category)

(rf/reg-sub ::default-category
  (fn [[_ auth-group-id _] _]
    (rf/subscribe [::entities/entity auth-group-id]))
  (fn [auth-group-entity [_ _ phrase-context]]
    (-> auth-group-entity
        (get (keyword phrase-context))
        :db/id)))

(rf/reg-sub ::categories
  (fn [[_ auth-group-id _] _]
    (rf/subscribe [::entities/entities {:entity/type            :entity.type/phrase-category
                                        :domain/authority-group auth-group-id}]))
  (fn [categories _]
    (sort-by :phrase.category/name categories)))

(defn default-category-selection [{:keys [tr class label-loc authority-group-id phrase-context]}]
  [:div.pb-2.mb-4 {:class class}
   (into (cc/select
           {:id         "category-selection"
            :label-text (tr [label-loc])
            :value      (or (<sub [::default-category authority-group-id phrase-context])
                            "all")
            :on-change  (fn [e]
                          (let [value (-> e futil/tval)]
                            (>evt [::update-default-category
                                   phrase-context
                                   (when-not (= value "all")
                                     (-> value js/parseInt))
                                   (= value "all")
                                   authority-group-id])))}
           (cc/select-item {:key   "placeholder-select-item"
                            :text  (tr [:phrase.category/all])
                            :value "all"}))
         (for-frag [category (<sub [::categories authority-group-id])]
           (cc/select-item {:text  (:phrase.category/name category)
                            :value (:db/id category)})))])

(defn initial-phrase-sort [phrases]
  (sort-by (juxt #(-> % :phrase/category :phrase.category/name)
                 :phrase/name)
           phrases))

(defn sort-rows [[attr descending?] rows]
  (if attr
    (let [sort-key-fn (case attr
                        :phrase.category/name #(-> % :phrase/category :phrase.category/name)
                        #(get % attr))]
      (sort-by sort-key-fn (if descending? > <) rows))
    rows))

(defn phrase-table [tr group-id phrases]
  (r/with-let [*sorting (r/atom [])
               *editing (r/atom #{})]
    (let [categories (<sub [::categories group-id])
          phrases    (cond->> phrases
                       (seq @*sorting) (sort-rows @*sorting)
                       (empty? @*sorting) initial-phrase-sort)]
      [#_{:clj-kondo/ignore [:deprecated-var]}
       ui-table/table {:tr    tr
                       :class "phrase-table table-fixed"}

       [[ui-table/table-header-sortable tr *sorting :phrase.category/name {:class "w-1/6"}]
        [ui-table/table-header-sortable tr *sorting :phrase/name {:class "w-1/4"}]
        [ui-table/table-header-sortable tr *sorting :phrase/text {:class "w-1/2"}]
        [:th {:class "w-1/12"} ""]]

       (for-all [{:db/keys [id] :as phrase} phrases
                 :let [editing? (contains? @*editing id)]]
         {:key  id
          :cols [{:content (if editing?
                             (cc/select
                               {:id         (str id "-category")
                                :label-text (tr [:phrase.category/name])
                                :hide-label true
                                :value      (-> phrase :phrase/category :db/id)
                                :on-change  #(>evt [::save-phrase
                                                    group-id
                                                    {:phrase-id       id
                                                     :phrase/category (-> % .-target .-value js/parseInt)}])
                                :class-name "full-width-select"}
                               (for-frag [category categories]
                                 (cc/select-item {:value (:db/id category)
                                                  :text  (-> category :phrase.category/name)})))
                             (-> phrase :phrase/category :phrase.category/name))}

                 {:content (if editing?
                             [ui/text-input {:id            (str id "-text")
                                             :label-text    (tr [:phrase/text])
                                             :default-value (-> phrase :phrase/name)
                                             :hide-label    true
                                             :on-change     #(>evt [::event/input-change
                                                                    [::save-phrase
                                                                     group-id
                                                                     {:phrase-id   id
                                                                      :phrase/name (-> % .-target .-value)}]])}]
                             (-> phrase :phrase/name))}

                 {:content ^{:key (hash (-> phrase :phrase/text))} ;; forces the editor to re-render when the text changes
                  [ui-rt/editor-legacy {:id            (str "phrase-text-" id)
                                        :initial-value (-> phrase :phrase/text)
                                        :on-change     (when editing? #(>evt [::event/input-change
                                                                              [::save-phrase
                                                                               group-id
                                                                               {:phrase-id   id
                                                                                :phrase/text %}]]))}]}

                 {:opts    {:class-name "table-row__actions"}
                  :content [:<>
                            (cc/icon {:icon        (if editing?
                                                     i/remove
                                                     i/pen)
                                      :class-name  "cursor-pointer"
                                      :description (if editing?
                                                     (tr [:cancel])
                                                     (tr [:edit]))
                                      :on-click    #(swap! *editing (if editing? disj conj) id)})
                            [ui/modal-confirmation-button {:tr                tr
                                                           :id                "delete-phrase"
                                                           :modal-title       (tr [:phrase/delete])
                                                           :trigger-icon-opts {:icon        i/trash
                                                                               :description (tr [:phrase/delete])
                                                                               :class-name  "cursor-pointer"}
                                                           :on-yes-click      #(>evt [::delete-phrase group-id (:db/id phrase)])}
                             (tr [:phrase/delete-confirm])]]}]})])))

(defn category-modal [tr group-id *modal-open?]
  (r/with-let [*category (r/atom "")]
    [ui-modal/composed-input-modal
     {:open                   @*modal-open?
      :selector-primary-focus "button.bx--modal-close"
      :on-close               (fn [_]
                                (reset! *modal-open? false)
                                (reset! *category "")
                                true)}
     (cc/modal-header
       {:close-modal (fn [_]
                       (reset! *modal-open? false))
        :title       (tr [:phrase/add-category])})
     (cc/modal-body
       {}
       [ui/text-input {:placeholder (tr [:phrase.category/name])
                       :label-text  (tr [:phrase.category/name])
                       :value       @*category
                       :on-change   #(reset! *category (-> % .-target .-value))}])
     (cc/modal-footer
       {}
       (cc/button
         {:kind     :tertiary
          :on-click (fn [_]
                      (reset! *modal-open? false)
                      (reset! *category ""))}
         (tr [:cancel]))
       (cc/button
         {:kind     :primary
          :on-click (fn [_]
                      (>evt [::create-category group-id @*category])
                      (reset! *modal-open? false)
                      (reset! *category ""))}
         (tr [:phrase/save-category])))]))

(defn category-edit [{:keys [tr group-id]}]
  [section/subsection-2 (util/mmap {:title                (tr [:phrase.category/edit])
                                    :initially-collapsed? true}
                                   tr)
   [ui-tag-type-editor/editor
    (util/mmap {:plain-strs?         true
                :values              (<sub [::categories group-id])
                :remove-confirmation (tr [:phrase.category/delete-confirm])
                :tag-type-name       (tr [:phrase.category/name])
                :on-delete           (fn [{:keys [:db/id]}]
                                       (>evt [::delete-category group-id id]))
                :on-create           (fn [{:keys [name on-done]}]
                                       (>evt [::create-category group-id (str/trim name) on-done]))
                :on-end-edit         (fn [{:keys [:phrase.category/name :db/id]}]
                                       (>evt [::edit-category group-id id name]))
                :name-attr           :phrase.category/name}
               tr)]])

(defn import-export-buttons [tr group-id]
  (let [importing? (<sub [:comm/command-processing? :group/import-standard-texts])]
    [:div.flex.gap-x-2.items-center
     [file-download/download-button
      :group/download-standard-texts
      {:group-id group-id}
      (tr [:standard-texts/export])
      {:kind              :tertiary
       :download-filename (str "standard-texts-" group-id ".xlsx")}]
     [upload/upload-button
      (str "standard-texts-import-" group-id)
      {:accept-types      ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                           "application/vnd.ms-excel"]
       :attach-file-v2-fn #(>evt [::import-standard-texts group-id %])
       :button-opts       {:kind             :tertiary
                           :icon             i/upload
                           :icon-description (tr [:standard-texts/import])
                           :disabled         importing?}
       :label-text        (tr [:standard-texts/import])}]
     (when importing?
       (cc/inline-loading {:description (tr [:standard-texts/import-processing])}))]))

(defn phrase-editor [tr group-id]
  (r/with-let [*editing?    (r/atom false)
               *modal-open? (r/atom false)
               initial-data {:phrase/name ""
                             :phrase/text ""}
               *phrase-data (r/atom initial-data)]
    [:div.phrase-editor.mt-6
     (when-not @*editing?
       [:div.flex.flex-wrap.items-center.gap-2
        (cc/button
          {:kind             :tertiary
           :icon             i/plus
           :icon-description (tr [:phrase/add])
           :on-click         #(reset! *editing? true)}
          (tr [:phrase/add]))
        (when (<sub [::ff/enabled? :feature-flag.id/standard-texts-import])
          [import-export-buttons tr group-id])])
     (when @*editing?
       (let [selected-category (<sub [::selected-phrase-category])]
         [:<>
          [:div.bx--row
           [category-modal tr group-id *modal-open?]
           [:h4.bx--col-xs-12.mb-3
            (tr [:phrase/add])]
           [:div.bx--col-xs-6.bx--col-md-3
            (cc/select {:id         "new-phrase-category"
                        :label-text (tr [:phrase.category/name])
                        :value      (or selected-category
                                        :none)
                        :on-change  #(>evt [::set-phrase-category (-> % .-target .-value js/parseInt)])
                        :class-name "full-width-select"}
                       (when-not selected-category
                         [ui/placeholder-select-item tr])
                       (for-frag [category (<sub [::categories group-id])]
                         (cc/select-item {:value (:db/id category)
                                          :text  (:phrase.category/name category)})))]
           [:div.bx--col-xs-6.bx--col-md-3
            [ui/text-input {:placeholder (tr [:phrase/name])
                            :label-text  (tr [:phrase/name])
                            :on-change   #(swap! *phrase-data assoc :phrase/name (-> % .-target .-value))}]]
           [:div.bx--col-xs-6.bx--col-md-6
            [ui-rt/editor-legacy {:id          "new-phrase-text"
                                  :placeholder (tr [:phrase/text])
                                  :label-text  (tr [:phrase/text])
                                  :on-change   #(swap! *phrase-data assoc :phrase/text %)}]]]
          [:div.bx--row.mt-3.justify-end
           [:div.flex.gap-x-2.pr-3
            (cc/button {:kind     :tertiary
                        :on-click #(reset! *editing? false)}
                       (tr [:cancel]))
            (cc/button {:kind             :primary
                        :icon             i/save
                        :icon-description (tr [:phrase/add])
                        :disabled         (or (some str/blank? (vals @*phrase-data))
                                              (nil? selected-category))
                        :on-click         (fn [_]
                                            (>evt [::save-phrase group-id (assoc @*phrase-data
                                                                                 :phrase/category selected-category)])
                                            (reset! *editing? false)
                                            (reset! *phrase-data initial-data))}
                       (tr [:phrase/save-phrase]))]]]))]))

(defn phrase-management [group-id]
  (let [tr      (<sub [::gas/group-tr])
        phrases (<sub [::entities/entities {:entity/type            :entity.type/phrase
                                            :domain/authority-group group-id}])]
    [:div.phrase-management
     [:div.mb-6 {:data-cy "category-edit-section"}
      [category-edit (util/mmap tr group-id)]]
     [:div.flex.flex-wrap
      [default-category-selection {:tr                 tr
                                   :class              "mr-4"
                                   :label-loc          :phrase/default-category
                                   :authority-group-id group-id
                                   :phrase-context     :group/phrase-category-verdicts}]
      (when (<sub [::condition-common/conditions-enabled-for-group? group-id])
        [default-category-selection {:tr                 tr
                                     :class              "mr-4"
                                     :label-loc          :phrase/default-for-conditions
                                     :authority-group-id group-id
                                     :phrase-context     :group/phrase-category-conditions}])
      [default-category-selection {:tr                 tr
                                   :label-loc          :phrase/default-for-review-comments
                                   :authority-group-id group-id
                                   :phrase-context     :group/phrase-category-review-comments}]]
     [phrase-table tr group-id phrases]
     [phrase-editor tr group-id]]))
